import makeReducer from '~app/core/makeReducer';

import * as LayerActions from '~app/actions/layers';

import AnthromeInfo from '~app/resources/data/anthrome-info';
import BiomeInfo from '~app/resources/data/biome-info';
import PrecipitationInfo from '~app/resources/data/precipitation-info';
import TemperatureInfo from '~app/resources/data/temperature-info';
import TerrainInfo from '~app/resources/data/terrain-info';

const initialState = {
  layers: [
    BiomeInfo,
    AnthromeInfo,
    TemperatureInfo,
    PrecipitationInfo,
    TerrainInfo,
  ],
  lowResLayers: [],
  activeLayerIndex: 0,
  activeMapIndex: 0,
  highResEnabled: true,
};

function clearLowResLayers(state) {
  return {
    ...state,
    lowResLayers: [],
  };
}

function cacheLowResLayers(state, {layers}) {
  return {
    ...state,
    lowResLayers: [...state.lowResLayers, ...layers],
  };
}

function setActiveLayerIndex(state, {index}) {
  return {
    ...state,
    activeLayerIndex: index,
    activeMapIndex: 0,
  };
}

function setActiveMapIndex(state, {index}) {
  return {
    ...state,
    activeMapIndex: index,
  };
}

function setHighRes(state, {enabled}) {
  return {
    ...state,
    highResEnabled: enabled,
  };
}

const ACTION_HANDLERS = {
  [LayerActions.CLEAR_LOW_RES_LAYERS]: clearLowResLayers,
  [LayerActions.CACHE_LOW_RES_LAYERS]: cacheLowResLayers,

  [LayerActions.SET_ACTIVE_LAYER_INDEX]: setActiveLayerIndex,
  [LayerActions.SET_MAP_INDEX]: setActiveMapIndex,

  [LayerActions.SET_HIGH_RES]: setHighRes,
};

export default makeReducer(ACTION_HANDLERS, initialState);



// WEBPACK FOOTER //
// ./src/store/layerReducer.js